import React from "react";
import * as validator from "../../../general/validators/validator";
import { Avatar, CircularProgress, RaisedButton, TextField } from "material-ui";
import Header from "../../header";
import * as LoginService from "../../../services/loginService";
import { Constants } from "../../../constants";
import {
  ERROR_FLOW_STEP_USER_TAKEN,
  PASSWORD_TOO_SHORT,
  WRONG_OLD_PASSWORD
} from "../../../general/response-codes";
import Select from "react-select";
import * as FlowService from "../../../services/flow-service";
import request from "../../../config/axios-config";
import * as ErrorAction from "../../../redux/action/error-action";
import { connect } from "react-redux";
import { DS } from "../../../theme-default";
import SignatureSettings from "./signature-settings";

class SettingsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      oldPassword: "",
      newPasswordFirst: "",
      newPasswordSecond: "",
      savingPassword: false,
      savingPasswordSuccessful: false,
      savingPasswordFailed: false,
      // Fallbacks of the step this user signs; no card while ownStep is null.
      ownStep: null,
      fallbackIds: [],
      userOptions: [],
      savingFallbacks: false,
      savingFallbacksSuccessful: false,
      savingFallbacksFailed: false,
      savingFallbacksError: "",
      error: {}
    };
  }

  componentDidMount() {
    if (this.props.isStepSigner) {
      this.loadOwnStep();
    }
  }

  componentDidUpdate(previousProps) {
    if (this.props.isStepSigner && !previousProps.isStepSigner) {
      this.loadOwnStep();
    }
  }

  // Any failure (including an older API without /flow/own-step) simply shows no card.
  loadOwnStep = () => {
    Promise.all([FlowService.getOwnStep(), request({ method: "get", url: "/user/all" })])
      .then(([own, usersJson]) => {
        if (!own.data || !own.data.flowStepId) {
          return;
        }
        const userOptions = (usersJson.data || [])
          .filter(t => t.id !== this.props.userId && t.isActive !== false)
          .map(t => ({ value: t.id, label: t.email }));
        this.setState({
          ownStep: own.data,
          fallbackIds: (own.data.fallbacks || []).map(f => f.id),
          userOptions: userOptions
        });
      })
      .catch(() => {
        this.setState({ ownStep: null });
      });
  };

  onFallbacksChanged = selected => {
    const userIds = (selected || []).map(option => option.value);
    const previous = this.state.fallbackIds;
    // Show the new selection right away, so a second pick builds on this one.
    this.setState({
      fallbackIds: userIds,
      savingFallbacks: true,
      savingFallbacksSuccessful: false,
      savingFallbacksFailed: false
    });
    FlowService.saveOwnFallbacks(userIds)
      .then(() => {
        this.setState({ savingFallbacks: false, savingFallbacksSuccessful: true });
      })
      .catch(err => {
        const code = err && err.response && err.response.data && err.response.data.message;
        this.setState({
          fallbackIds: previous,
          savingFallbacks: false,
          savingFallbacksFailed: true,
          savingFallbacksError:
            code === ERROR_FLOW_STEP_USER_TAKEN
              ? "Persoana aprobă deja alt pas al fluxului; doar administratorul o poate adăuga ca înlocuitor."
              : "Salvarea a eșuat. Vă rog reîncercați!"
        });
      });
  };

  onClickChangePassword = () => {
    if (!this.validateChangePassword()) {
      return;
    }
    this.setState({
      savingPassword: true
    });
    LoginService.changePassword(
      this.state.oldPassword,
      this.state.newPasswordFirst
    )
      .then(t => {
        this.setState({
          savingPasswordSuccessful: true,
          savingPassword: false,
          oldPassword: "",
          newPasswordFirst: "",
          newPasswordSecond: ""
        });
      })
      .catch(err => {
        let error = {};
        if (err.response.data.message === WRONG_OLD_PASSWORD) {
          error.summary = "Parola veche e gresita!";
        } else if (err.response.data.message === PASSWORD_TOO_SHORT) {
          error.summary = "Parola noua e prea scurta!";
        } else {
          error.summary = "A aparut o eroare. Va rog reincercati!";
        }
        this.setState({
          savingPasswordSuccessful: false,
          savingPassword: false,
          savingPasswordFailed: true,
          error: error
        });
      });
  };

  validateChangePassword = () => {
    let error = {};
    let isOk = true;
    /**/
    if (validator.isEmpty(this.state.oldPassword)) {
      error.oldPassword = "Lipseste parola veche";
      isOk = false;
    }
    if (validator.isEmpty(this.state.newPasswordFirst)) {
      error.newPasswordFirst = "Lipseste parola noua";
      isOk = false;
    }
    if (validator.isEmpty(this.state.newPasswordSecond)) {
      error.newPasswordSecond = "Lipseste parola noua";
      isOk = false;
    }
    if (
      !validator.isEmpty(this.state.newPasswordFirst) &&
      !validator.isEmpty(this.state.newPasswordSecond) &&
      this.state.newPasswordFirst !== this.state.newPasswordSecond
    ) {
      error.newPasswordSecond = "Ati gresit parola";
      isOk = false;
    }
    if (
      isOk &&
      this.state.newPasswordFirst.length < Constants.MIN_PASSWORD_LENGTH
    ) {
      error.newPasswordSecond = "Parola e prea scurta. Minim 6 caractere";
      isOk = false;
    }

    this.setState({
      error: error
    });

    return isOk;
  };

  render() {
    return (
      <div>
        <Header title={"Setari cont"} />

        <SignatureSettings />

        <div style={{ maxWidth: 480, margin: "16px auto 0" }}>
          <div className="ds-card">
            <div>
              <h4 style={{ marginTop: 0 }}>Schimbati parola:</h4>

              <TextField
                fullWidth
                type={"password"}
                floatingLabelText={"Parola veche"}
                autoComplete="new-password"
                value={this.state.oldPassword}
                errorText={this.state.error.oldPassword}
                onChange={e => this.setState({ oldPassword: e.target.value })}
              />

              <TextField
                fullWidth
                type={"password"}
                floatingLabelText={"Parola noua"}
                autoComplete="new-password"
                value={this.state.newPasswordFirst}
                errorText={this.state.error.newPasswordFirst}
                onChange={e =>
                  this.setState({ newPasswordFirst: e.target.value })
                }
              />

              <TextField
                fullWidth
                type={"password"}
                floatingLabelText={"Repetati noua parola"}
                autoComplete="new-password"
                value={this.state.newPasswordSecond}
                errorText={this.state.error.newPasswordSecond}
                onChange={e =>
                  this.setState({ newPasswordSecond: e.target.value })
                }
              />
              <RaisedButton
                style={{ marginTop: 16 }}
                primary
                label={"Schimba"}
                onClick={() => this.onClickChangePassword()}
              />
            </div>

            <div>
              {this.state.savingPassword && (
                <CircularProgress style={{ marginTop: "10px" }} />
              )}

              {this.state.savingPasswordSuccessful && (
                <strong style={{ color: DS.success, marginTop: "10px" }}>
                  Parola a fost schimbata cu succes!
                </strong>
              )}

              {this.state.savingPasswordFailed &&
                this.state.error.summary && (
                  <strong style={{ color: DS.error, marginTop: "10px" }}>
                    {this.state.error.summary}
                  </strong>
                )}
            </div>
          </div>

          {this.props.isStepSigner && this.state.ownStep && (
            <div className="ds-card" style={{ marginTop: 16 }}>
              <h4 style={{ marginTop: 0 }}>
                Înlocuitori pentru pasul «{this.state.ownStep.calling}»
              </h4>
              <div style={{ fontSize: "12px", color: DS.textMuted, marginBottom: 8 }}>
                Oricare dintre ei poate aproba sau respinge în locul dumneavoastră; primul
                care o face închide pasul.
              </div>
              <Select
                multi
                options={this.state.userOptions}
                name="fallbacks"
                value={this.state.fallbackIds}
                placeholder="Fără înlocuitori"
                onChange={this.onFallbacksChanged}
                searchable={true}
              />
              <div style={{ marginTop: 8 }}>
                {this.state.savingFallbacks && <CircularProgress size={24} />}
                {this.state.savingFallbacksSuccessful && (
                  <strong style={{ color: DS.success }}>
                    Înlocuitorii au fost salvați.
                  </strong>
                )}
                {this.state.savingFallbacksFailed && (
                  <strong style={{ color: DS.error }}>
                    {this.state.savingFallbacksError}
                  </strong>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    userId: state.login.user.id,
    isStepSigner: state.login.user.isStepSigner
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showError: text => dispatch(ErrorAction.showError(text)),
    hideError: () => dispatch(ErrorAction.hideError())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SettingsPage);
